import { BusinessScope } from "@lib/constants/business-scope";

export class User {
  id!: string;

  country!: string;

  language!: string;

  readOnlyAccess!: boolean;

  role!: any;

  productFruitsHmac!: string;

  firstName!: string;

  lastName!: string;

  email!: string;

  scope!: BusinessScope;

  showZrefPrices: boolean = false;

  constructor() {}
}
